import React from 'react';
import { NavLink } from 'react-router-dom';
import Logo from '../ui/Logo';
import Icon from '../ui/Icon';

const navClass = ({ isActive }) =>
  `btn-ghost px-3 py-2 ${isActive ? 'text-ink-100 bg-ink-750' : ''}`;

/**
 * App Header Component
 * Single Responsibility: Top navigation shared by every page
 */
const AppHeader = ({ children, right }) => (
  <header className="sticky top-0 z-30 border-b border-ink-700/60 bg-ink-900/80 backdrop-blur-md" style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}>
    <div className="max-w-7xl mx-auto flex items-center gap-3 px-4 h-14">
      <Logo />
      {children ? (
        <div className="flex items-center gap-2 min-w-0 flex-1 pl-2 ml-1 border-l border-ink-700">{children}</div>
      ) : (
        <nav className="hidden sm:flex items-center gap-1 ml-4 flex-1">
          <NavLink to="/" end className={navClass}>Courses</NavLink>
          <NavLink to="/course-creator/new" className={navClass}>
            <Icon name="plus" size={16} /> Create a course
          </NavLink>
        </nav>
      )}
      {right && <div className="flex items-center gap-2 ml-auto">{right}</div>}
    </div>
  </header>
);

export default AppHeader;
